export const LOAD_DOCUMENT_PROPERTIES_SUCCESS = "LOAD_DOCUMENT_PROPERTIES_SUCCESS";
export const LOAD_DOCUMENT_PROPERTIES_STARTED = "LOAD_DOCUMENT_PROPERTIES_STARTED";
export const LOAD_DOCUMENT_PROPERTIES_FAILED = "LOAD_DOCUMENT_PROPERTIES_FAILED";
export const UPDATE_DOCUMENT_PROPERTIES_SUCCEEDED = "UPDATE_DOCUMENT_PROPERTIES_SUCCEEDED";
